// 9fbef606107a605d69c0edbcd8029e5d
import { REDEEMED_AND_EARNED_PERKS_ACTION_PATTERN } from '@tcp/core/src/constants/reducer.constants';

export default {
  GET_REDEEMED_AND_EARNED_PERKS: `${REDEEMED_AND_EARNED_PERKS_ACTION_PATTERN}GET_REDEEMED_AND_EARNED_PERKS`,
  SET_REDEEMED_AND_EARNED_PERKS: `${REDEEMED_AND_EARNED_PERKS_ACTION_PATTERN}SET_REDEEMED_AND_EARNED_PERKS`,
  CLEAR_REDEEMED_AND_EARNED_PERKS: `${REDEEMED_AND_EARNED_PERKS_ACTION_PATTERN}CLEAR_REDEEMED_AND_EARNED_PERKS`,
  SHOW_LOADER: `${REDEEMED_AND_EARNED_PERKS_ACTION_PATTERN}SHOW_LOADER`,
  HIDE_LOADER: `${REDEEMED_AND_EARNED_PERKS_ACTION_PATTERN}HIDE_LOADER`,
  REDEEMED_AND_EARNED_PERKS_FETCH_CACHE_TTL: 15 * 60 * 1000,
};
